import { Component, Input, OnInit } from '@angular/core';
import { DataAlertMiniCard } from '../../../interfaces/dash-alerts-interfaces';

@Component({
  selector: 'status-mini-card',
  templateUrl: './status-mini-card.component.html',
  styleUrls: ['./status-mini-card.component.scss'],
})
export class StatusMiniCardComponent implements OnInit {
  @Input() data: DataAlertMiniCard;
  constructor() {}

  ngOnInit() {}
}
